<template>
    <div>
        <swb-query-sort-area ref="query_model" :config="queryConfig" :queryKey="queryKey" :queryHandler="queryHandler"></swb-query-sort-area>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);

    let searchConfigData = {
        "queryFields": [
            {
                "type": "Text",
                "label": "联系电话",
                "valueType": "String",
                "code": "contactTel",
                "basic": true
            },
            {
                "type": "Text",
                "label": "员工姓名",
                "code": "name",
                "basic": true
            },
            {
                "type": "Select",
                "label": "是否离职",
                "dataList": [
                    {
                        "value": null,
                        "label": "-全部-"
                    },
                    {
                        "value": "true",
                        "label": "是"
                    },
                    {
                        "value": "false",
                        "label": "否"
                    }
                ],
                "code": "quit",
                "basic": true
            },
            {
                "type": "Date2",
                "label": "入职时间",
                "valueType": "Date",
                "code": "enrollDate"
            }
        ],
        "sortFields": [
            {
                "order": "asc",
                "label": "员工姓名",
                "code": "name",
                "enabled": true
            },
            {
                "order": "desc",
                "label": "入职日期",
                "code": "enrollDate",
                "enabled": true
            },
            {
                "order": "asc",
                "label": "离职日期",
                "code": "quitDate",
                "enabled": true
            }
        ]
    };

    export default {
        name: 'swb-staff-role-search',
        desc: '公司员工列表搜索',
        data: function () {
            return {
                queryConfig: null,
                queryKey: null,
                queryConfigMap: {}
            }
        },
        created: function () {
            //查询排序配置信息
            let queryConfig = searchConfigData || {};
            //查询回调函数调用上下文对象
            //queryConfig.queryContext = this;
            //...
            this.queryConfig = queryConfig;

            this.queryConfigMap = queryConfig.queryFields.toMap("code");
            //从缓存恢复查询条件模型
            let query_model_ctrl = this.$refs['query_model'];
            if(query_model_ctrl != null) {
                let queryModelCache = query_model_ctrl.getModel();
                if(queryModelCache) {
                    this.queryModel = queryModelCache;
                    console.log('已从缓存中恢复查询条件');
                }
            }
        },
        methods: {
            queryHandler(queryModel) {
                console.log('----------  查询、排序参数 ---------');

                console.log(queryModel);

                this.$emit("queryHandler", queryModel)
                //调用查询...
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/authx/StaffRoleSearch.vue